import ApiServer from '@/utils/api/ApiServer.js'

export default {
  async createYardInstruction (_, yardInstruction) {
    const path = `locations/${yardInstruction.locationId}/yardinstructions`
    const response = await ApiServer.post(path, yardInstruction)
    return response.data
  },

  async fetchYardInstructions (_, locationId) {
    const path = `locations/${locationId}/yardinstructions`
    const response = await ApiServer.get(path)
    return response.data
  },

  async fetchYardInstructionById (_, { locationId, yardInstructionId }) {
    const path = `locations/${locationId}/yardinstructions/${yardInstructionId}`
    const response = await ApiServer.get(path)
    return response.data
  },

  async updateYardInstruction (_, yardInstruction) {
    const path = `locations/${yardInstruction.locationId}/yardinstructions/${yardInstruction.yardInstructionId}`
    const response = await ApiServer.put(path, yardInstruction)
    return response.data
  },

  async deleteYardInstruction (_, yardInstruction) {
    const path = `locations/${yardInstruction.locationId}/yardinstructions/${yardInstruction.yardInstructionId}`
    const response = await ApiServer.delete(path)
    return response.data
  }
}
